import {
  Box,
  useTheme,
  Typography,
  Paper,
  Divider,
  Chip,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PaymentStatusChanger from "../edit/status-chenger/PaymentStatusChanger";
import { Styles } from "./styles";

const CustomOfferReview = ({ data = {}, refetch }) => {
  const [formData, setFormData] = useState(data);
  const theme = useTheme();

  const calculateDiscount = () => {
    if (data.discount_type === "const") {
      return data.discount;
    }
    return parseFloat((data.price * data.discount) / 100).toFixed(2);
  };

  const sectionHeadingStyle = {
    fontWeight: 600,
    color: theme.palette.primary.dark,
    p: 1.5,
    borderRadius: "4px 4px 0 0",
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    mb: 2,
  };

  useEffect(() => {}, [formData]);

  return (
    <Styles>
      <Box sx={{ width: "100%", p: 2 }}>
        <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
          {/* Main Order Header */}
          <Box
            sx={{
              mb: 3,
              backgroundColor: theme.palette.grey[100],
              p: 2,
              borderRadius: 1,
              borderLeft: `4px solid ${theme.palette.primary.main}`,
            }}
          >
            <Typography
              variant="h5"
              component="h1"
              sx={{ fontWeight: 600, color: theme.palette.primary.main }}
            >
              Request #{data.request_id || "N/A"}
            </Typography>
            <Chip
              label={data.status_payment}
              color={
                data.status_payment === "paid"
                  ? "success"
                  : data.status_payment === "pending"
                  ? "warning"
                  : "error"
              }
              sx={{ mt: 1 }}
            />
          </Box>

          <Divider sx={{ my: 2 }} />

          <Grid container spacing={3}>
            {/* Request Details */}
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ height: "100%" }}>
                <Typography variant="h6" sx={sectionHeadingStyle}>
                  Request Details
                </Typography>
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                  }}
                >
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      Request ID
                    </Typography>
                    <Typography>{data.request_id || "N/A"}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      User Name
                    </Typography>
                    <Typography>{data.user?.name || "N/A"}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      Offer ID
                    </Typography>
                    <Typography>{data.offer_id || "N/A"}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      Payment Method
                    </Typography>
                    <Typography sx={{ textTransform: "capitalize" }}>
                      {data.payment_method || "N/A"}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>

            {/* Price Details */}
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ height: "100%" }}>
                <Typography variant="h6" sx={sectionHeadingStyle}>
                  Price Details
                </Typography>
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                  }}
                >
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      Original Price
                    </Typography>
                    <Typography>${data.price || "0.00"}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      Discount (
                      {data.discount_type === "const" ? "Fixed" : "Percentage"})
                    </Typography>
                    <Typography>${calculateDiscount()}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">
                      Final Amount
                    </Typography>
                    <Typography variant="h6" color="primary">
                      ${(data.price - calculateDiscount()).toFixed(2)}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>

            {/* Offer Details */}
            {data.RequestOfferDetails?.map((offer) => (
              <Grid item xs={12} key={offer.id}>
                <Paper elevation={0} sx={{ p: 2 }}>
                  <Typography variant="h6" sx={sectionHeadingStyle}>
                    Offer #{offer.id}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Service Name
                      </Typography>
                      <Typography>{offer.our_service_name || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Count (Days/Tickets)
                      </Typography>
                      <Typography>
                        {offer.days || offer.count_ticket || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Title
                      </Typography>
                      <Typography>{offer.title || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Description
                      </Typography>
                      <Typography>{offer.description || "N/A"}</Typography>
                    </Grid>
                    {offer.logo && (
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" color="textSecondary">
                          Logo
                        </Typography>
                        <img
                          src={offer.logo}
                          alt="Offer logo"
                          style={{ maxWidth: 200, height: "auto" }}
                        />
                      </Grid>
                    )}
                    {offer.customLogo && (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "6px",
                          height: "200px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "18px",
                            lineHeight: "28px",
                            color: "#474747",
                          }}
                        >
                          Your Logo Demo
                        </Typography>
                        <Box
                          sx={{
                            background:
                              "radial-gradient(circle, #51AAFD, #002D68)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            overflow: "hidden",
                            padding: {
                              xs: "40px",
                              sm: "40px 20px",
                              md: "40px",
                            },
                            borderRadius: "15px",
                            width: "130px",
                            height: "100px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: `${offer.customLogo.fontSize}px`,
                              fontWeight: "700",
                              color: offer.customLogo.color,
                              fontFamily: offer.customLogo.fontFamily,
                            }}
                          >
                            {offer.customLogo.logoName}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Grid>
                </Paper>
              </Grid>
            ))}

            {/* Payment Document */}
            {data.payment_document && (
              <Grid item xs={12}>
                <Paper elevation={0}>
                  <Typography variant="h6" sx={sectionHeadingStyle}>
                    Payment Document
                  </Typography>
                  <Box
                    sx={{
                      p: 2,
                      maxWidth: 400,
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: 1,
                    }}
                  >
                    <img
                      src={data.payment_document}
                      alt="Payment Document"
                      style={{ width: "100%", height: "auto", borderRadius: 4 }}
                    />
                  </Box>
                </Paper>
              </Grid>
            )}

            {/* Payment Note */}
            {data.payment_note && (
              <Grid item xs={12}>
                <Paper elevation={0}>
                  <Typography variant="h6" sx={sectionHeadingStyle}>
                    Payment Note
                  </Typography>
                  <Box sx={{ p: 2 }}>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 2,
                        backgroundColor: theme.palette.background.default,
                      }}
                    >
                      <Typography>{data.payment_note}</Typography>
                    </Paper>
                  </Box>
                </Paper>
              </Grid>
            )}

            {/* Status Changer */}
            {/*{data?.payment_method === "manually" &&*/}
            {/*  data?.status_payment === "pending" && (*/}
            {/*    <Grid item xs={12}>*/}
            {/*      <Paper elevation={0}>*/}
            {/*        <Typography*/}
            {/*          variant="h6"*/}
            {/*          sx={{*/}
            {/*            ...sectionHeadingStyle,*/}
            {/*            backgroundColor: theme.palette.warning.light,*/}
            {/*            borderBottom: `2px solid ${theme.palette.warning.main}`,*/}
            {/*          }}*/}
            {/*        >*/}
            {/*          Update Payment Status*/}
            {/*        </Typography>*/}
            {/*        <Box sx={{ p: 2 }}>*/}
            {/*          <PaymentStatusChanger*/}
            {/*            data={data}*/}
            {/*            setData={setFormData}*/}
            {/*            rowsPerPage={1}*/}
            {/*            currentPage={1}*/}
            {/*            source={"customOfferReview"}*/}
            {/*            refetch={refetch}*/}
            {/*          />*/}
            {/*        </Box>*/}
            {/*      </Paper>*/}
            {/*    </Grid>*/}
            {/*  )}*/}
          </Grid>
        </Paper>
      </Box>
    </Styles>
  );
};

export default CustomOfferReview;
